<wms-dialog-header title="{{locale[dialogHeader]}}" dialogclass="widget-config-dialog team-publish-dialog large project wm-studio-dialog select-platform" name="wm-publish-team-dialog" (onClose)="closePublishDialog()"> </wms-dialog-header>
  <wms-dialog-body>
    <wms-spinner *ngIf="processing || validatingVersion" name="artifact-pane-spinner"></wms-spinner>
    <wms-wizard [steps]="steps" [counter]="stepCounter" [show]="!isPublishSuccessful" ></wms-wizard>
    <div class="wms-wizard-body">
      <div class="wms-wizard-title" *ngIf="steps[stepCounter].description && !isPublishSuccessful">
        <span title="{{steps[stepCounter].description}}" class="col-xs-12">{{steps[stepCounter].description}}</span>
      </div>
      <ng-template class="wms-wizard-body-content" [ngTemplateOutlet]="getStepTemplate()"></ng-template>

    </div>
  </wms-dialog-body>

    <wms-dialog-footer>
      <button (click)="closePublishDialog()" *ngIf="!isPublishSuccessful && !draftAlert" [disabled]="isFinalStep() && processing" class="btn app-button button-secondary" title="{{locale.LABEL_CANCEL}}">{{locale.LABEL_CANCEL}}</button>
      <button name="btn-prev-page" *ngIf="!isPublishSuccessful && !draftAlert  && stepCounter !== 0" [disabled]="isFinalStep() && processing" (click)="decrementStep()" class="btn app-button button-tertiary" title="{{locale.LABEL_BACK}}">{{locale.LABEL_BACK}}</button>
      <button name="btn-next-page" *ngIf="!isPublishSuccessful && !draftAlert" [disabled]="validateCurrentStep() || validatingVersion || (isFinalStep() && processing)" (click)="incrementStep()" class="btn button-primary">{{nextBtnText}}</button>
      <button name="cancel-prefab-publish" (click)="closePublishDialog()" *ngIf="isPublishSuccessful || draftAlert" class="btn app-button button-secondary" title="{{locale.LABEL_CLOSE}}"><span class="btn-caption">{{locale.LABEL_CLOSE}}</span></button>
    </wms-dialog-footer>
<ng-template #informationScreen>
  <wms-ptt-information [artifactPublishDetails]="artifactPublishDetails" [categories]="categories" [dependencies]="dependencies"
                       [isNewArtifact]="isNewArtifactObj" [artifactDetails]="artifactObj"
                       [processing]="processing" [draftAlert]="draftAlert"></wms-ptt-information>
</ng-template>

<ng-template #configurationScreen>
  <wms-ptt-configuration [artifactPublishDetails]="artifactPublishDetails"></wms-ptt-configuration>
</ng-template>


<ng-template #summaryScreen>
  <wms-ptt-summary [artifactPublishDetails]="artifactPublishDetails" [isPublishSuccessful]="isPublishSuccessful"
                   [showErrMsg]="showErrMsg" [errMsg]="errMsg" [successMessage]="successMessage"></wms-ptt-summary>
</ng-template>


